function hasValue(value) {
  return value !== undefined &&
    value !== null &&
    String(value).trim() !== '';
}

/**
 * Read a public runtime setting from window.ENV_CONFIG and fall back to the
 * corresponding Vue CLI build-time environment variable.
 */
export function getEnvValue(runtimeKey, buildKey) {
  const runtimeConfig = typeof window !== 'undefined' && window.ENV_CONFIG
    ? window.ENV_CONFIG
    : {};
  const runtimeValue = runtimeConfig[runtimeKey];

  if (hasValue(runtimeValue)) {
    return String(runtimeValue).trim();
  }

  const buildValue = process.env[buildKey];
  return hasValue(buildValue) ? String(buildValue).trim() : '';
}

/**
 * Join a base URL and path without producing a missing or duplicate slash.
 */
export function joinUrl(baseUrl, path) {
  const base = String(baseUrl || '').trim().replace(/\/+$/, '');
  const suffix = String(path || '').trim().replace(/^\/+/, '');

  return base && suffix ? `${base}/${suffix}` : base || suffix;
}
